import React, { useContext } from "react";

import style from "./ProgressBar.module.css";
import ColourContext from "../../contexts/ColourContext";
import { colourThemes } from "../../styles/colourPalettes";

type ProgressBarProps = {
  percent: number;
};

const ProgressBar = ({ percent }: ProgressBarProps) => {
  const { key: colourkey } = useContext(ColourContext);
  const colour = colourThemes[colourkey];
  return (
    <div className={style.progress}>
      <div
        style={{
          backgroundColor: colour,
          opacity: 0.3,
        }}
      />
      <div
        style={{
          backgroundColor: colour,
          transform: `translateX(${-(100 - percent)}%)`,
        }}
      />
    </div>
  );
};

export default ProgressBar;
